<template>
  <div class="Markdown">
    <Editor
      ref="editor"
      :configs="configs"
      :modelValue="valueFormatted"
      @update:modelValue="emitValue" />
    <slot />
  </div>
</template>

<script>
import 'simplemde/dist/simplemde.min.css'
import Editor from 'vue-simplemde'

const hashSingle = /# /g
const hashTriple = /### /g

export default {
  components: { Editor },
  props: {
    value: null,
  },
  data() {
    return {
      configs: {
        forceSync: true,
        showIcons: [
          'strikethrough',
        ],
        spellChecker: false,
        status: false,
      },
    }
  },
  computed: {
    valueFormatted() {
      return this.value.replace(hashSingle, '### ')
    },
  },
  methods: {
    refresh() {
      this.$refs.editor.simplemde.value(this.valueFormatted)
    },
    emitValue(value) {
      const valueOutput = value.replace(hashTriple, '# ')

      this.$emit('update:value', valueOutput)
    },
  },
}
</script>

<style lang="scss">
.Markdown {
  .CodeMirror {
    z-index: 0;

    h3 {
      font-size: $h4;
      margin-top: $grid-unit;

      &:first-of-type {
        margin-top: 0;
      }
    }

    p {
      margin: $grid-unit-half 0;
    }

    ul {
      margin-left: $grid-unit;
    }

    pre, ul {
      line-height: $lh;
    }
  }
}
</style>
